<template>
  <main class="queue-selection-arena-new">
    <div class="arena-body">
      <!-- 欢迎界面 -->
      <WelcomeSection v-if="venueInfo.status === 1" :venue-info="venueInfo" :requirement-pool="requirementPool" :team-list="teamList" @change="$emit('change')" />

      <!-- 选择进行中 -->
      <SelectionSection v-if="venueInfo.status === 2" :venue-info="venueInfo" :requirement-pool="requirementPool" :team-list="teamList" :pending-records="pendingRecords" @change="$emit('change')" />

      <!-- 结果展示 -->
      <ResultsSection v-if="venueInfo.status === 3" :venue-info="venueInfo" :requirement-pool="requirementPool" :team-list="teamList" />
    </div>
  </main>
</template>

<script>
import WelcomeSection from './WelcomeSection.vue';
import SelectionSection from './SelectionSection.vue';
import ResultsSection from './ResultsSection.vue';

export default {
  name: 'QueueSelectionArenaNew',
  components: {
    WelcomeSection,
    SelectionSection,
    ResultsSection
  },
  props: {
    venueInfo: {
      type: Object,
      default: () => ({})
    },
    initialRequirements: {
      type: Array,
      default: () => []
    },
    initialTeams: {
      type: Array,
      default: () => []
    },
    pendingRecords: {
      type: Array,
      default: () => []
    }
  },
  emits: ['change'],
  data() {
    return {
      // 核心状态
      requirementPool: [],
      teamList: []
    };
  },
  computed: {},
  watch: {
    initialRequirements: {
      handler(newRequirements) {
        // 适配API响应数据结构
        this.requirementPool = newRequirements.map(req => ({
          ...req,
          id: req.id,
          source_id: req.source_id,
          source_name: req.source_name,
          description: req.description || '',
          status: req.status,
          winner: req.winner,
          selectionTime: req.selectionTime || null
        }));
      },
      immediate: true,
      deep: true
    },
    initialTeams: {
      handler(newTeams) {
        this.teamList = newTeams.map(team => ({
          id: team.id,
          name: team.name,
          ready: team.ready,
          ownerId: team.ownerId
        }));
      },
      immediate: true,
      deep: true
    },
    pendingRecords: {
      handler() {
        // pendingRecords变化时自动触发计算属性更新
      },
      immediate: true,
      deep: true
    }
  },

  methods: {}
};
</script>

<style lang="less" scoped>
.queue-selection-arena-new {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  position: relative;
  color: #1e293b;
}

.arena-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-bottom: 1px solid rgba(79, 70, 229, 0.1);
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  position: relative;
  z-index: 2;

  .arena-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 600;
    color: #1e293b;

    .anticon {
      color: #4f46e5;
      font-size: 20px;
    }

    .arena-subtitle {
      font-size: 12px;
      opacity: 0.7;
      margin-left: 8px;
      color: #64748b;
      font-weight: 400;
    }
  }
}

.arena-body {
  flex: 1;
  overflow: hidden;
}
</style>
